export default __webpack_public_path__ + "static/media/upi-icon.79bd7d92.svg";